import {BehaviorSubject, Subject} from 'rxjs';
import Subscribed from "./models/symbolData"

interface Buysell {
    model_open: boolean;
    data: Subscribed | null;
}
const subject = new BehaviorSubject<Subscribed>({
    ask: 0,
    ask_qty: 0,
    bid: 0,
    bid_qty: 0,
    buySellSymbol: "",
    ch: 0,
    chp: 0,
    description: "",
    dpr: "0-0",
    exchange: "",
    high_price: 0,
    low_price: 0,
    lp: 0,
    market_segment_id: "",
    oi: "0",
    oi_ch: "0",
    open_price: 0,
    option_type: "",
    prev_close_price: 0,
    short_name: "",
    token: "",
    type: "",
    volume: 0,
});


// layOut subServices
const layoutSub = new BehaviorSubject(null)
export const layoutSubServices = {
    setLayOut: (data:any) => {
        layoutSub.next(data)
    },
    getSub: () => layoutSub.asObservable(),
};

const ResponceStatusSubject = new Subject();
export const ResponceStatusService = {
    sendRes: (data:any) => subject.next(data),
    getSub: () => subject.asObservable()
};
